import { useState } from 'react';
import { IconDown, IconUp } from '@ui/src';
import { AddressTypes } from './types';

import cn from './styles.module.css';

const StepPartBlock = ({
  title,
  children,
  zIndex,
  withoutTitle,
}: AddressTypes) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div
      className={`${cn.stepPartWrapper} ${withoutTitle ? cn.stepPartWrapperWithoutTitle : ''}`}
      style={{ position: 'relative', zIndex }}
    >
      {!withoutTitle && (
        <button
          type="button"
          className={cn.stepPartTitle}
          onClick={() => setExpanded(!expanded)}
        >
          {title}
          {expanded ? <IconUp /> : <IconDown />}
        </button>
      )}

      {expanded && <div className={cn.stepPartContent}>{children}</div>}
    </div>
  );
};

export default StepPartBlock;
